import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CryptoService } from '../crypto.service';
import { MorseComponent } from '../morse/morse.component';

@Component({
  selector: 'app-t-learn-by-heart',
  templateUrl: './t-learn-by-heart.component.html',
  styleUrls: ['./t-learn-by-heart.component.css']
})
export class TLearnByHeartComponent extends GeneralTeacherComponent {

  hints: string ="";

  @ViewChild('morse', {static:true})
  private morse: MorseComponent;

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected http: HttpClient, public cryptoService: CryptoService) {
    super(topicService, activatedRoute)
    this.type = "learnByHeart"
    this.title = this.get("learnByHeart");
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.hints = this.configuration.typespecifics.hints;
    this.onChangeHints();
  }

  generateDefinition(): any {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/learnByHeart.png";
    definition.level = 3;
    definition.key = "crypto%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.hints = this.hints;
    definition.key = definition.key.concat("%", this.hints);

    return definition;
  }

  reset() {
    super.reset();
    this.title = this.get("learnByHeart");
    this.hints = "";
    this.onChangeHints();
  }

  /** normalizes the hint and sets them */
  onChangeHints() {
    this.hints = this.cryptoService.normalizeText(this.hints);
    let hintsToWrite = [];
    for (let hint of this.hints) {
      hintsToWrite[hint.charCodeAt(0) - 65] = this.cryptoService.encodeMorse(hint);
    }
    this.morse.setHints(hintsToWrite);
  }
}
